import React from "react";
import dummylogo from '../../assests/dummylogo.png'
import { GoOrganization } from "react-icons/go";
export default function ExperienceCard({
  company,
  completionDate,
  designation,
  joiningDate


}) {
  return (
    <div className="flex items-center space-x-4 p-4 border-b border-gray-200 rounded-lg ">
      <GoOrganization className="text-primary text-[7rem]" />
      {/* <img src={dummylogo} alt={company} className="w-[] h-[85px] md:w-24 md:h-24 rounded-md" /> */}
      <div className="flex flex-col-reverse justify-end w-[100%] h-[100%] pt-[2%]">
        <span className="flex flex-col md:flex-row md:flex-wrap md:justify-between w-[100%] pt-2 space-y-1">
          <p className="text-gray-500 text-xs md:text-lg mr-5">Designation: {designation}</p>
          <p className="text-gray-500 text-xs md:text-lg">Date of Joining: {joiningDate}</p>
          <p className="text-gray-500 text-xs md:text-lg">
            Date of Resignation: {completionDate}
          </p>
        </span>
        <h2 className="text-xl font-semibold ">{company}</h2>
      </div>
    </div>
  );
}
